let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kpUvw")).then(() => parcelRequire('gT0r7'));